<template>
  <v-row justify="center">
    <v-dialog v-model="isShow" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t(title) }}</v-card-title>
        <v-card-text>{{ $t(msg, { verb: $t(verbMsg) }) }}</v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="_blue" outlined text @click="$emit('cancel')">{{ $t('cancel') }}</v-btn>
          <v-btn color="_blue" class="white--text" @click="$emit('confirm')">{{ $t('ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    msg: {
      type: String,
      required: true,
    },
    verbMsg: {
      type: String,
      default: '',
    },
  },
};
</script>
